export const VUE_APP_API_FLOWS_BASE_URL="https://uyj2oz4mhd.execute-api.us-east-2.amazonaws.com/prod";
export const VUE_APP_API_CAMPAINGS_BASE_URL="https://s8iss3lcia.execute-api.us-east-2.amazonaws.com/prod";
export const VUE_APP_API_INBOXES_BASE_URL="https://pp74ocije4.execute-api.us-east-2.amazonaws.com/prod";
export const VUE_APP_API_TYPEBOT_BASE_URL="https://app-tyb.notifai.pe"
// The embed signing key lives in the Rails environment (METABASE_SECRET_KEY). Do not export it here.
export const METABASE_SITE_URL = "https://mb1.notifai.pe";
export const METABASE_DASHBOARD_CONTACTS = 88; // Replace with actual dashboard ID
export const METABASE_DASHBOARD_CONVERSATIONS = 87; 
export const METABASE_DASHBOARD_BILLING = 89;  
export const VUE_APP_API_AI_AGENTS_BASE_URL="https://s8iss3lcia.execute-api.us-east-2.amazonaws.com/prod";
export const METABASE_DASHBOARD_LAIVE = 56;